// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"738c35c5","20":"86e7fc06","36":"0d4ca186","150":"e538ee54","401":"457b2a61","423":"5e921149","553":"c641e1ce","554":"78d431dd","706":"2b8e5c62","837":"d4f3ff53","840":"43d46cde","906":"ef49299e","954":"00b60f7e","964":"cb2d42af"}[chunkId] + ".chunk.js";
};